export default "__VITE_ASSET__Ds1AOqi5__"